import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import MonthlyMarketing from './pages/MonthlyMarketing';
import UniteNationTech from './pages/UniteNationTech';
import MarketingStrategy from './pages/MarketingStrategy';
import DigitalMarketing from './pages/DigitalMarketing';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Contact from './pages/Contact';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/monthly-marketing" element={<MonthlyMarketing />} />
          <Route path="/unite-nation-tech" element={<UniteNationTech />} />
          <Route path="/marketing-strategy" element={<MarketingStrategy />} />
          <Route path="/digital-marketing" element={<DigitalMarketing />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
